import { render, staticRenderFns } from "./Box1.vue?vue&type=template&id=4442e3c8&scoped=true"
import script from "./Box1.vue?vue&type=script&lang=js"
export * from "./Box1.vue?vue&type=script&lang=js"
import style0 from "./Box1.vue?vue&type=style&index=0&id=4442e3c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4442e3c8",
  null
  
)

export default component.exports